<template>
  <v-menu
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    v-model="menuValue"
    class="guests-field"
    content-class="guests-field_menu"
    z-index="99999"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        solo
        readonly
        class="ui-input"
        hide-details
        v-on="on"
        :value="total"
      />
    </template>

    <div class="guests-field_container">
      <div class="guests-field_header">
        <span class="guests-field_title">Гости</span>
        <v-btn class="guests-field_close" icon  @click="menuValue = false"><v-icon>$cross</v-icon></v-btn>
      </div>

      <div
        v-for="i in data"
        :key="i.id"
        class="guests-field_item"
      >
        <div class="guests-field_item-body">
          <span class="guests-field_item-title">{{ i.title }}</span>
          <span class="guests-field_item-subtitle">{{ i.subtitle }}</span>
        </div>

        <div class="guests-field_counter">
          <ui-counter
            @update="(v) => onUpdate(i.id, v)"
            :value="i.value"
            :min="i.min"
          />
        </div>
      </div>

      <div class="guests-field_footer">
        <v-btn class="ui-btn guests-field_action" @click="menuValue = false">Готово</v-btn>
      </div>
    </div>
  </v-menu>
</template>

<script>

export default {
  name: 'GuestsField',

  props: {
    data: {
      type: Array,
      required: true,
    },
  },

  data: () => ({
    menuValue: false,
  }),

  computed: {
    total() {
      return this.data.reduce((acc, cur) => acc += +cur.value, 0)
    },
  },

  methods: {
    onUpdate(id, value) {
      this.$emit('update', { id, value })
    }
  }
}
</script>

<style lang="sass">
.guests-field_header
  width: 100%
  display: none
  align-items: center
  justify-content: space-between
  margin-bottom: px-em(32)

.guests-field_title
  font-size: px-em(20)

.guests-field_close
  font-size: px-em(12) !important

  .v-icon
    font-size: inherit !important

.guests-field_footer
  margin-top: 32px
  display: none

.guests-field_action
  width: 100%

.guests-field_menu
  background-color: #fff
  padding: px-em(16)

.guests-field_item
  width: 100%
  display: flex
  align-items: center
  justify-content: space-between
  gap: px-em(16)

  + .guests-field_item
    margin-top: px-em(16)

.guests-field_item-body
  max-width: px-em(150)

.guests-field_item-title
  display: block

.guests-field_item-subtitle
  display: block
  color: #6A6E75

@media screen and (max-width: 600px)
  .v-menu__content.theme--light.menuable__content__active.guests-field_menu
    position: fixed
    display: flex

  .guests-field_header
    display: flex

  .guests-field_footer
    display: block

  .guests-field_menu
    font-size: px-em(16,12)
    position: fixed
    inset: 0 !important
    max-width: 100% !important
    transform-origin: bottom !important
    background-color: rgba(0,0,0, .2)
    padding: 0
    display: flex
    align-items: flex-end

  .guests-field_container
    width: 100%
    flex-shrink: 0
    background-color: #fff
    padding: px-em(20) px-em(16) px-em(40)
    border-top-right-radius: px-em(20)
    border-top-left-radius: px-em(20)
</style>
